export default __webpack_public_path__ + "static/media/carved_ring.dba88097.png";